import { disciplinesMiddleware } from './discipline-middleware';
import { acrMiddleware } from './acr-middleware';
import { familyInfoMiddleware } from './family-info-middleware';
import { generalInfosMiddleware } from './general-info-middleware';
import { postingsMiddleware } from './postings-middleware';
import { qualificationMiddleware } from './qualification-middleware';
import { servicesMiddleware } from './services.middleware';
import { aprMiddleware } from './apr-middleware';
import { attachedFilesMiddleware } from './attachedFiles-middleware';

export const employeeMiddleware = [
  generalInfosMiddleware,
  familyInfoMiddleware,
  postingsMiddleware,
  servicesMiddleware,
  qualificationMiddleware,
  disciplinesMiddleware,
  acrMiddleware,
  aprMiddleware,
  attachedFilesMiddleware,
];
